// 시안 'OfferGroup B2 — Light Immersive' 의 x-dc 스크립트에서 옮겨온 상수.

/** 접수(상담) 페이지 주소 — 헤더 버튼과 사업영역 카드에서 쓴다. */
export const APPLY_PATH = '/bnpl';

export const NAV = [
  { id: 'about', label: '회사소개' },
  { id: 'business', label: '사업영역' },
  { id: 'tech', label: '기술혁신' },
  { id: 'hiks', label: 'HIKS' },
  { id: 'people', label: '인재·문화' },
  { id: 'impact', label: '사회적 가치' },
];

/** 회사소개 우측 3줄 */
export const PILLARS = [
  { no: '01', title: '기술 혁신', body: 'AI와 데이터 기반의 비즈니스 업무 혁신' },
  { no: '02', title: '기업 간 연결', body: '협력과 네트워크를 통한 새로운 성장 기회' },
  { no: '03', title: '지속가능한 가치', body: '기업·사람·사회가 함께 성장하는 선순환' },
];

/** 사업영역 — 왼쪽 목록을 고르면 오른쪽 카드가 바뀐다 */
export const BUSINESS = [
  {
    title: 'AI & 데이터 인텔리전스',
    body: '업무 자동화와 데이터 분석 기술을 연구하며 기업의 의사결정과 생산성 향상을 지원합니다.',
    tag: 'AI R&D · DATA',
    cta: '기술혁신 알아보기 ↗',
    href: '#tech',
  },
  {
    title: 'B2B 비즈니스 솔루션',
    body: '기업 간 협업과 비즈니스 운영을 지원하고 거래·유통 업무의 효율성을 높입니다.',
    tag: 'B2B · BNPL',
    cta: 'BNPL 서비스 알아보기 ↗',
    href: APPLY_PATH,
  },
  {
    title: 'HIKS 플랫폼',
    body: '기업과 정보, 기술과 기회를 연결하는 디지털 협력 생태계를 지향합니다.',
    tag: 'PLATFORM · 준비 중',
    cta: 'HIKS 살펴보기 ↗',
    href: '#hiks',
  },
  {
    title: 'ERP & 디지털 전환',
    body: '운영 과정의 데이터를 체계화하고 업무 프로세스의 디지털 전환을 추진합니다.',
    tag: 'ERP · DX',
    cta: '자세히 보기 ↗',
    href: '#tech',
  },
];

/** 기술혁신 — 스크롤에 따라 하나씩 또렷해지는 네 단계 */
export const TECH_STEPS = [
  {
    title: 'Business Experience',
    sub: '기업 운영과 협업 경험',
    body: '다양한 기업과 함께한 실무 운영 경험이 모든 기술의 출발점입니다.',
  },
  {
    title: 'Data Intelligence',
    sub: '데이터 정제·연결·고도화',
    body: '흩어진 기업 정보와 거래 데이터를 체계적으로 연결하고 분석합니다.',
  },
  {
    title: 'AI Innovation',
    sub: '분석·자동화·업무 혁신 연구',
    body: 'AI 기반 업무 지원 및 지능형 솔루션을 연구합니다.',
  },
  {
    title: 'B2B Synergy',
    sub: '기업 간 협업과 성장 가치 확대',
    body: '기술의 결과가 기업 간 협력과 새로운 성장 기회로 이어지도록 합니다.',
  },
];

export const HIKS_POINTS = [
  { title: '정보 접근성 향상', body: '필요한 정보를 보다 쉽게' },
  { title: '기업 간 연결', body: '새로운 협업 기회 확대' },
  { title: '기술 활용 확대', body: '기업의 디지털 전환 지원' },
  { title: '동반성장 추구', body: '중소기업 경쟁력 강화' },
];

/** 인재·문화 가치 — 고른 항목의 file 사진이 왼쪽에 보인다 (public/corporate 기준) */
export const VALUES = [
  {
    key: 'VALUE',
    title: '가치 성장',
    body: '지속적인 학습과 경험을 통해 개인의 전문성과 역량을 발전시키는 환경',
    file: 'value-growth.jpg',
  },
  {
    key: 'TOGETHER',
    title: '동반 성장',
    body: '조직과 구성원의 성장이 서로의 기회로 이어지는 선순환',
    file: 'value-together.jpg',
  },
  {
    key: 'OPPORTUNITY',
    title: '기회 제공',
    body: '연차보다 역량과 도전을 존중하며 더 큰 역할에 참여할 수 있는 기회',
    file: 'value-opportunity.jpg',
  },
  {
    key: 'WELLBEING',
    title: '복지와 환경',
    body: '업무 몰입과 삶의 균형을 돕는 근무환경 및 실질적인 복지의 지속적인 발전',
    file: 'value-wellbeing.jpg',
  },
];

/** 업무환경 사진 3장 — file 이 비어 있으면 자리표시로 그린다 (public/corporate 기준) */
export const WORKSPACES = [
  {
    label: '사옥 외관',
    eyebrow: 'HEADQUARTERS',
    placeholder: '사옥 외관 사진',
    file: 'ws-hq.png',
  },
  {
    label: '집중과 협업을 위한 공간',
    eyebrow: 'WORKSPACE',
    placeholder: '업무·협업 공간 사진',
    file: 'ws-office.png',
  },
  {
    label: '일상 속 쉼과 교류',
    eyebrow: 'LOUNGE & CAFE',
    placeholder: '라운지·카페 사진',
    file: 'ws-lounge.png',
  },
];

/** 사회적 가치 — 펼침 목록 */
export const IMPACT = [
  {
    title: 'HIKS 기반의 기회 확대',
    body: '기업 정보와 협력 기회에 대한 접근성을 높이는 플랫폼 추진',
  },
  { title: '중소기업 경쟁력 강화', body: '기술과 운영 효율화를 통한 기업 성장 지원' },
  {
    title: '양질의 일자리와 포용적 고용',
    body: '인재 성장과 다양한 구성원의 기회를 확대하는 방향 추구',
  },
  { title: '지역사회와 동반 성장', body: '기업 활동이 지역과 산업 생태계에 기여하도록 노력' },
];

/** 히어로 하단과 문의 섹션 아래를 흐르는 문구 */
export const MARQUEE_WORDS = [
  'AI R&D',
  'DATA INTELLIGENCE',
  'ERP INTEGRATION',
  'PROCESS AUTOMATION',
  'HIKS PLATFORM',
  'B2B SOLUTIONS',
];

/** 성장 지표 */
export const GROWTH = {
  eyebrow: '고객과 함께 증명한 성장 · 2021 → 2025',
  value: 65800,
  caption: '2021년 대비 2025년 매출 증가율',
  headline: ['기업의 가능성을 연결하며,', '오퍼그룹도 함께 성장했습니다.'],
};
